export const enLocalisation = {
  units: {
    hour: 'hour',
    hour_other: 'hours',
    day: 'day',
    day_other: 'days',
    week: 'week',
    week_other: 'weeks',
    month: 'month',
    month_other: 'months',
    year: 'year',
    year_other: 'years',
  },
  common: {
    address: 'Address',
    copy: 'Copy',
    dismiss: 'Dismiss',
    send: 'Send',
    back: 'Back ',
    password: 'Password',
    continue: 'Continue',
    enterTokenName: 'Search token',
    enterChainName: 'Search chain',
    understood: 'Understood',
    save: 'Save',
    update: 'Update',
    cancel: 'Cancel',
    principalId: 'Principal ID',
    accountId: 'Account ID',
    swap: 'Swap',
    mint: 'Mint',
    approve: 'Approve',
    confirm: 'Confirm',
    add: 'Add',
    max: 'Max',
    bridge: 'Bridge',
    today: 'Today',
    yesterday: 'Yesterday',
    areYouSure: 'Are you sure?',
    yes: 'Yes',
    errors: {
      gasError: 'Could not calculate gas fee',
    },
    manage: 'Manage',
    modify: 'Modify',
    close: 'Close',
    withdraw: 'Withdraw',
  },
  welcome: {
    title: 'Plug into Crypto',
    description:
      'You can import an existing wallet, create a new wallet, or use a seed phrase to restore a wallet',
    create: 'Create a new wallet',
    import: 'Import wallet',
    connectII: 'Connect with Internet Identity',
    connectOisy: 'Connect with Oisy',
    otherOptions: 'Other options',
    previousAuth: 'Continue with your previous sign-in method',
    taglineLine1: 'one wallet.',
    taglineLine2: 'every chain.',
    lead: 'Hold, send and swap BTC, ETH, SOL, ICP, Doge and more from one wallet you control. Powered by Chain Fusion.',
    signIn: 'Sign in',
    welcomeBack: 'Welcome back',
    moreOptions: 'Other sign in options',
    lastUsed: 'Last used',
    recommended: 'Recommended',
    connectPlugWallet: {
      title: 'Connect with Plug Wallet',
      description: 'Choose how you want to connect your existing Plug Wallet',
      importSeed: 'Import existing seed phrase',
      plugExtension: 'Connect with Plug Extension',
    },
  },
  passwordSetup: {
    title: 'Create your password',
    description: 'Choose a password to secure & lock your wallet',
    set: 'Set password',
    password: 'Password (min 8 characters)',
    repeatPassword: 'Repeat password',
    passwordError: 'Password has to be at least 8 characters long',
    repeatedPasswordError: 'Repeated password has to be equal to password',
  },
  walletSuccess: {
    title: 'Wallet Created Successfully',
    description: 'Click Plug from Extension drop-down to access your wallet',
  },
  topbar: {
    settings: 'Settings',
    qr: 'My QR',
    contacts: 'Contacts',
    lock: 'Lock',
    help: 'Help',
    documentation: 'Documentation',
    support: 'Support',
  },
  manageTokens: {
    title: 'Manage Tokens',
    sections: {
      essential: 'Essential',
      custom: 'Custom',
      sns: 'SNSs',
      other: 'Other Tokens',
      'chain-fusion': 'Chain Fusion',
    },
    addCustom: 'Add custom token',
    removeToken: 'Remove {{symbol}}',
    selectStandard: 'Select Standard',
    tokenAddress: 'Token Address',
    tokenAlreadyExists: 'Token already exists',
    tokenAddError:
      'Unable to fetch token metadata. Please check that you have entered correct address and standard',
  },
  contacts: {
    addNew: 'Add New',
    addAddress: 'Add Address',
    addresses: 'Addresses',
  },
  nft: {
    title: 'NFTs',
    openAsset: 'Open Asset',
    sendNft: 'Send',
    noInfo: 'No information available',
    about: 'About',
    collection: 'Collection',
    info: 'Information',
    rarity: 'Rarity',
    number: 'Number',
    inscribed: 'Inscribed',
    standard: 'Standard',
    value: 'Value',
  },
  send: {
    title: 'Send',
    amount: 'Amount',
    canisterTopup: 'Top-Up Canister',
    errors: {
      lowBalance: 'Not enough {{token}}',
      notEnoughForFee: 'Not enough {{token}} for TX fee',
      noAmount: 'Please enter amount',
      tooSmall: 'Amount is smaller than {{amount}}',
      xtcNoMode: 'Please select XTC send mode',
      notEnoughSolForRent:
        "You have to either fully deduct your SOL balance or leave at least {{rentFee}} SOL to cover your account's rent cost",
      ownWallet: "Can't send to your own wallet",
      noOrdinals: "Couldn't fetch ordinals",
      calculatingFee: 'Calculating fee',
    },
    contacts: {
      contacts: 'Contacts',
      wallets: 'Your other wallets',
      canisters: 'Saved Canisters',
      plugbook: 'Plugbook',
    },
    noTokens: "Don't see token you're looking for?",
    findTokens: 'Try balance sync',
    to: 'To',
    excludedOrdinals: 'All ordinals are excluded: {{ordinals}} ',
    selectedOrdinal: 'Selected ordinal',
    inputs: 'Inputs',
    addressField: {
      send: {
        title: 'To',
        placeholder: 'Principal, Account, Contact or Plugbook ID',
      },
      cycleTopup: {
        title: 'To',
        placeholder: 'Canister Address',
      },
    },
    review: {
      title: 'Review {{action}}',
      sent: 'Send Completed',
      toppedUp: 'Top-up Completed',
      checkingReceiver: 'Checking the receiver',
    },
    canisterReceives: 'Canister receives:',
    fee: 'Network Fee',
    warnings: {
      firstTimeSend: 'First time sending to this address',
      failedFirstTimeSendCheck:
        'Failed to check previous interactions with the receiver, make sure the address is correct!',
    },
  },
  tokens: {
    sections: {
      all: 'All',
      sns: 'SNSs',
      essential: 'Essential',
      popular: 'Popular',
      eth: 'ETH',
      sol: 'SOL',
    },
    unavailableAnalytics: 'Analytics for this token are not available',
  },
  swap: {
    title: 'Swap',
    reviewSwap: 'Review Swap',
    completed: 'Swap Completed',
    fallback: "Haven't received tokens? Try fallback",
    provider: 'Provider',
    price: 'Price',
    config: 'Swap Config',
    slippage: 'Slippage',
    slippageCustom: 'Custom',
    balance: 'Balance',
    priceDifference: 'Price difference',
    errors: {
      no_amount: 'Please enter amount',
      no_quote: 'Fetching Price',
      less_than_minimal: 'Amount less than minimal',
      not_enough_token: 'Not enough {{token}}',
      not_enough_token_for_fee: 'Not enough {{token}} to cover transaction fee',
      no_quote: 'No offers found',
      no_token: 'Please select token',
      loading_price: 'Loading price',
      slippage_exceeded: 'Max slippage is exceeded',
      slippageTooHigh: 'Too high (Significant loss)',
      no_fee: "Couldn't calculate network fee",
      not_enough_for_gas: 'Not enough funds for gas, please try swapping less',
      unknown_error: 'An unknown error occurred, please contact Plug support if the issue persists',
    },
    steps: {
      undefined: 'Initializing',
      transfer: 'Transfering tokens',
      approve: 'Approving tokens',
      deposit: 'Depositing to pool',
      swap: 'Performing swap',
      withdraw: 'Withdrawing funds',
      errorFallback: 'Error - falling back',
    },
    searchPair: 'Search Swap Pair',
    fallbackICPSwap: 'Still no luck? Try Reclaim on ICPSwap directly',
    odin: {
      btcBalanceTitle: 'Not seeing Odin BTC balance?',
      btcBalanceDescription: 'To swap Odin tokens you need to bridge your ckBTC to Odin BTC.',
      bridge: 'Bridge to Odin BTC',
    },
    picker: {
      token: {
        from: 'Select from token',
        to: 'Select to token',
      },
      chain: {
        from: 'Select from chain',
        to: 'Select to chain',
      },
    },
    priceDifferenceWarning: {
      title: 'Warning',
      description:
        'The price difference of this exchange is below recommended, which means you will receive less than you give.',
      confirm: 'Execute the trade anyway',
    },
  },
  swapDetails: {
    valueUSD: 'Amount in USD',
    slippage: 'Slippage',
    price: 'Price',
    earnings: 'Total Earnings',
    exchangeRate: 'Exchage Rate',
  },
  settings: {
    appearance: {
      primaryText: 'Appearance',
      secondaryText: 'Choose how Plug looks',
      dark: 'Dark',
      flux: 'Flux',
    },
    seedPhrase: {
      primaryText: 'Reveal Seed Phrase',
      secondaryText: 'View your secret recovery phrase',
    },
    dapps: {
      primaryText: 'Connected dApps',
      secondaryText: 'Manage dApps wallet is connected to',
    },
    pem: {
      primaryText: 'Export PEM',
      secondaryText: 'Export your private PEM key',
    },
    testnet: {
      primaryText: 'Developer Zone',
      secondaryText: 'Developer settings',
    },
    locale: {
      primaryText: 'Currency',
      secondaryText: 'Set your preferred currency',
    },
    evms: {
      primaryText: 'Ethereum Chains',
      secondaryText: 'Manage EVMs visible in Plug Wallet',
    },
    logout: {
      primaryText: 'Sign out',
      secondaryText: 'Sign out and clear cached data from this device',
    },
  },
  tokenDetails: {
    withdrawFromOdin: 'Withdraw from odin.fun',
    addFavorite: 'Add to favorites',
    removeFavorite: 'Remove from favorites',
    chartRange: 'Chart range',
    topUpCanisters: 'Top Up Canisters',
    depositToOdin: 'Deposit to Odin',
    today: 'Today',
    yesterday: 'Yesterday',
    description: 'Description',
    lastTransactions: 'Latest Transactions',
    utxos: 'Utxos',
  },
  transactionHistory: {
    failed: 'Failed',
    empty: 'No transactions',
    emptyMessage:
      'Use your plug wallet - send, swap, bridge tokens - and your activity will appear here',
    searchPlaceholder: 'Search by token',
    transactionsTab: 'Transactions',
    swapsTab: 'Swaps',
    convertsTab: 'Converts',
    commissionInfo:
      'This is a swap commission transfer, incurred automatically by Plug when you are swapping tokens through Plug Wallet',
    details: {
      date: 'Date',
      time: 'Time',
      from: 'From',
      to: 'To',
      viewDetails: 'View on explorer',
      fiatValue: 'Exchange rate',
      bridgeRoute: 'Bridged',
    },
    filter: 'Filter Transactions',
    filters: {
      Transfer: '💸 Transfer',
      Approve: '✅ Approve',
      Burn: '🔥 Burn',
      Mint: '☘️ Mint',
    },
    transactionKinds: {
      transfer: {
        sent: 'Sent',
        received: 'Received',
      },
      approved: 'Approved',
      burned: 'Burned',
      minted: 'Minted',
      swapped: 'Swapped',
      deposited: 'Deposited',
      withdrew: 'Withdrew',
    },
    pending: 'Pending',
  },
  approveTransaction: {
    icrc25_request_permissions: {
      title: 'Connect',
      description:
        'Confirming will allow this site to perform the following actions for the selected account.',
    },
    icrc49_call_canister: {
      title: 'Wants to authorize request',
      description: '',
    },
    icrc49_call_canister_compatibility: {
      title: 'Wants to authorize request',
      description: '',
    },
    icrc34_delegation: {
      title: 'Create Delegation',
      description:
        'Confirming will create delegation (this will allow dApp to call canister without confirmations from Plug)',
    },
    icrc57_get_session_delegation: {
      title: 'Create Session Delegation',
      description:
        'Confirming will allow this site to perform calls on your account behalf for the selected account.',
    },
    request_transfer: {
      title: 'Approve transfer',
      description: 'Confirming will authorize token transfer from the selected account.',
    },
    request_burn_xtc: {
      title: '🔥 Burn XTC',
      description: 'Confirming will authorize cycle transfer to a canister',
    },
    personal_sign: {
      title: 'Message to sign: ',
      additionalInformation: 'Additional Information: ',
      gasInfo: 'Signing this message does not cost any gas or initiate atransaction.',
      warning: 'Make sure you trust the site requesting this signature.',
    },
  },
  transferEth: {
    loading: 'Loading...',
    warning: 'Unable to verify contract details. Proceed at your own risks',
    gasWarning: 'Unable to estimate gas. Proceed at your own risks',
    info: 'Info',
    params: {
      title: 'Parameters',
      transferAmount: 'Transfer Amount',
      token: 'Token',
      receiver: 'Receiver',
      sender: 'Sender',
      function: 'Function',
      functionType: 'Function Type',
      hexData: 'Hex Data',
    },
  },
  authorizationRequest: {
    icrc49_call_canister: 'Call canisters',
    icrc49_call_canister_compatibility: 'Call canisters (Legacy)',
    icrc34_delegation: 'Get delegation',
    icrc27_accounts: 'Get accounts',
    globalDelegationWarningTitle: 'Global Delegation permission request',
    readMore: 'Click to read more',
    globalDelegationWarning:
      'By granting global delegation to token canisters dApp will have full control over your funds on target token canister',
    eth_accounts: 'Access your Ethereum addresses and suggest transactions',
  },
  importWallet: {
    title: 'Import seed phrase',
    description: 'Please enter your 12 or 24 word secret recovery phrase',
    placeholder: 'Enter 12 or 24 word secret recovery phrase',
    initializing: 'Setting up your new wallet...',
    new: {
      title: 'Create new Wallet',
      description: 'This will create new subaccount wallet from original seed phrase',
    },
    privateKey: {
      title: 'Import Private Key',
      description: 'Add an existing wallet with previously saved Private Key ',
    },
    stoic: {
      title: 'Import from Stoic seed phrase',
      description: 'You can import individual Stoic account by entering old seedphrase',
    },
    error: 'Wallet import error',
    invalidSeed: 'Your provided seed phrase is invalid',
  },
  depositCrypto: {
    principalId: 'Principal ID',
    principalIdDescription:
      "Use when receiving from Plug accounts & users, or other apps that support sending directly to Principal ID's",
    accountId: 'Account ID',
    accountIdDescription:
      "Use when receiving from exchanges, or other apps that only support sending to Account ID's",
    buyCrypto: 'Buy Crypto',
    buyCryptoDescription: 'You can easily buy ICP, ETH & BTC with our fiat on-ramp provider',
  },
  mintBtc: {
    ckbtcTitle: 'Use native BTC to mint ckBTC',
    ckbtcDescription:
      'Chain-key BTC (ckBTC) is an ICRC-1-compliant token that is backed 1:1 by bitcoin held 100% on chain',
    directPurchase: 'Direct purchase',
    onrampDescription: 'Use fiat on-ramp providers to deposit BTC and mint ckBTC',
    confirmationDescription: 'Mainnet ckBTC requires 12 confirmations',
    btcTransactions: 'BTC transactions',
    updateBalance: 'update ckBTC balance',
    buy: 'Buy Bitcoin',
  },
  mintCk: {
    title: 'Convert to Chain-Key',
    errors: {
      notEnough: 'Not enough {{token}}',
      notEnoughForGas: 'Not enough {{token}} for gas',
      noAmount: 'Please enter amount',
      fetchingGas: 'Fetching gas fee',
      noGasFee: 'No gas fee available',
      tokenNotFound: 'Token not found',
    },
    inputPlaceholder: 'Enter amount',
    gasFee: 'Gas fee',
    delay: 'Delay',
    delayTime: 'Up to 20 minutes',
    review: 'Review mint',
    failed: 'Mint failed',
    receiveAmount: 'Receive amount',
    mint: 'Mint',
    unmint: 'Unmint',
    mintFailed: 'Failed to mint',
    unmintFailed: 'Failed to unmint',
    mintFailedDescription: 'Please try again and/or contact Plug support team 😔',
    delayWarning: 'It might take up to 2 minutes to complete. Please do not close the window',
    noData: 'Required data not present',
    updateBalance: 'Update ckBTC balance',
    ckBtcBalance: 'ckBTC balance',
    titleAbout: 'What are CK tokens?',
    about:
      'Chain-Key (CK) tokens are created using ICP’s cryptographic protocols, enabling secure cross-chain use without intermediaries. Each CK token is backed 1:1 by its original asset, held entirely onchain by a smart contract.',
  },
  keyRevealAcceptance: {
    doNotShare: 'Never share you seed phrase or enter it into any apps',
    hide: 'Make sure nobody can see your screen when viewing your seed phrase',
    access: 'Anyone with your seed phrase will have full access to your wallet',
    support: 'Plug support will NEVER ask for your seed phrase',
    passwordTitle: 'Enter your Plug password',
    passwordDescription: 'Please enter your current password in order to proceed',
    beforeWeProceed: 'Before we proceed',
    revealSeedPhrase: 'Reveal seed phrase',
    downloadPem: 'Download PEM',
    pemDownloadAlert: 'On rarest ocassions should you download your PEM private key',
    accessPem: 'Anyone with your PEM private key will have full access to your wallet',
    pemSupport: 'Plug support will NEVER ask for your private key',
    unencryptedPem: 'Make sure you store downloaded file in a secure location as it is UNENCRYPTED',
  },
  connectedApps: {
    emptyTitle: 'No connections',
    emptyDescription:
      'Start by connecting your plug wallet to dApps, active connections will appear here',
  },
  deposit: {
    addressCopied: 'Address copied',
  },
  discover: {
    articles: 'Articles',
    volume: '24h Volume',
    leaderboard: 'Leaderboard',
    dapps: 'dApps',
    tokens: 'Tokens',
    searchPlaceholder: 'Search tokens, links, dApps',
    noResults: 'No results found',
  },
  seedBackup: {
    copied: 'Seed phrase copied',
    title: 'Backup seed phrase',
    description: 'Below is the seed phrase for your new wallet, write it down',
  },
  unlock: {
    title: 'Unlock',
    moreOptions: 'Unable to access your account? Try restoring',
    logoutWarning: {
      title: 'Warning!',
      description:
        'By continuing you will be logged out and all your settings will be reset to defaults',
      confirm: 'I understand',
      cancel: 'Take me back',
    },
  },
  home: {
    copyDescription: 'Copy account id for sending from exchanges and principal id for ICP network',
    copyAddress: 'Copy Plug Address',
    selectInterval: '📅 Select interval',
    tokenListButtons: {
      manage: 'Manage',
      findTokens: 'Sync',
      addChain: 'Add Chain',
    },
    perps: 'Perps',
    borrowLend: 'Borrow & Lend',
  },
  perps: {
    maxLeverage: 'Max Leverage: {{maxLeverage}}x',
    positions: 'Positions',
    activity: 'Recent Activity',
    addFunds: 'Add Funds',
    withdraw: 'Withdraw',
    availableBalance: 'Available balance',
    balance: 'Perps balance',
    perps: 'Perps',
    learnBasics: 'Learn the basics of trading perps',
    open: 'Open {{type}}',
    availableToTrade: 'Available to trade',
    size: 'Size',
    liquidationPrice: 'Liquidation Price',
    margin: 'Margin',
    leverage: 'Leverage',
    closePosition: 'Close position',
    type: {
      long: 'Long',
      short: 'Short',
    },
    editAction: {
      increase: {
        title: 'Add to Position',
        description: 'Increase your current exposure',
      },
      reduce: {
        title: 'Reduce Position',
        description: 'Lower your exposure by closing part of your position',
      },
    },
    editType: {
      increase: 'Increase',
      reduce: 'Reduce',
    },
    errors: {
      loadingPrice: 'Loading Price',
      noAmount: 'Please enter amount',
      excessiveReduction: 'Excessive reduction',
      minOrderSize: 'Min order size {{size}}',
      notEnoughBalance: 'Not enough balance',
    },
    details: {
      date: 'Date',
      price: 'Price',
      fee: 'Fee',
      pnl: 'PNL',
      roi: 'ROI',
      size: 'Size',
      margin: 'Margin (Isolated)',
      direction: 'Direction',
      entryPrice: 'Entry Price',
      dayVolume: '24h Volume',
      openInterest: 'Open Interest',
      funding: 'Funding',
      provider: 'Provider',
      closePosition: 'Close Position',
      yourPosition: 'Your Position',
    },
    history: {
      emptyList: 'No perpetual future trades made',
      emptyListDescription: 'Open a Long or Short order and they will appear here',
    },
  },
  borrowLend: {
    title: 'Borrow & Lend',
    borrow: 'Borrow',
    supply: 'Lend',
    withdraw: 'Withdraw',
    repay: 'Repay',
    signing: 'Signing',
    debt: 'Debt',
    apy: 'Supply APY',
    apr: 'Borrowing APR',
    creditTime: 'Credit time',
    creditTimeValue: 'A few minutes',
    completed: '{{action}} Completed',
    sent: '{{action}} Sent',
    markets: 'Markets',
    pendingActivities_one: '{{count}} operation is being processed',
    pendingActivities_other: '{{count}} operations are being processed',
    onboarding: {
      title: 'Get started with Liquidium',
      description:
        'Create a Liquidium profile to start lending and borrowing. Your profile is linked to this wallet by signing with its Ethereum address.',
      createProfile: 'Create profile',
    },
    errors: {
      title: 'Error',
      loading: 'Loading',
      amountTooSmall: 'Amount too small',
      amountTooBig: 'Amount too big',
      supplyToBorrow: 'Supply tokens to borrow',
      notEnoughSupply: 'Not enough tokens supplied',
      notEnoughBalance: 'Not enough balance',
      tokenNotDefined: 'Token is not defined',
      exceedsDebt: 'Amount exceeds debt',
      supplyCap: 'Supply cap reached',
      borrowCap: 'Borrow cap reached',
      noAmount: 'Please enter amount',
      exceedsMaxLtv: 'Amount exceeds your borrowing power',
    },
    portfolioHealth: {
      title: 'Health',
      description: 'Indicates the safety of your borrowing positions',
      liquidationDescription:
        'Automatic liquidations of supplied assets happen to repay your bad dept and maintain pool health for the lenders',
    },
    healthPositionDescriptions: {
      low: 'Position open to liquidation',
      medium: 'Moderate borrowing capacity',
      high: 'No debt - maximum safety',
    },
    positions: {
      noPositions: 'No Positions',
      availableBalance: 'Available Balance',
      supplyFirstTitle: 'Lend to Borrow',
      supplyFirstDescription: 'Lend assets as collateral before borrowing',
      startLending: 'Start Lending',
    },
    tabs: {
      borrowing: 'Borrowing',
      lending: 'Lending',
    },
  },
  importPrivateKey: {
    import: 'Import',
    alreadyExists: 'This principal already exists',
    dropHere: 'Drop files here',
    dragAndDrop: "Drag 'n' drop or click to select your private key (.pem file)",
  },
  newNetwork: {
    name: {
      title: 'Name',
      placeholder: 'Enter network name',
    },
    host: {
      title: 'Host URL',
      placeholder: 'http://127.0.0.1:5000',
    },
    create: 'Create new network',
    update: 'Update Network',
  },
  ethPermission: {
    ethAccounts: 'Access your Ethereum addresses and suggest transactions',
    notSupported: 'Currently not supported',
  },
  stake: {
    title: 'Staking',
    failedToLoadData: 'Failed to load data, please try again later 😔',
    noAmount: 'Please enter amount',
    depositTooSmall: 'Minimum deposit amount is {{minDeposit}} ICP',
    withdrawTooSmall: 'Minimum withdraw amount is {{minWithdraw}} nICP',
    notEnough: 'Not enough {{tokenSymbol}}',
    stakeIcp: 'Stake ICP',
    unstakeNicp: 'Unstake nICP',
    exchangeRate: 'Exchange Rate',
    receiveAmount: 'You Receive',
    futureReward: 'Future Airdrop',
    staked: 'Stake Completed',
    unstaked: 'Unstake Completed',
    chooseUnstakeMode: 'Please choose unstake mode',
    noSwapQuotesAvailable: 'No swap offers available',
    titleAbout: 'What is nICP?',
    about: `nICP is a token representing ICP locked in a 6-month neuron. You can benefit from the yield generated by the neuron while still having liquid tokens.`,
    unstake: {
      immediate: {
        short: 'Immediately',
        title: 'Unstake immediately',
        description: 'Swap nICP for ICP immediately using most profitable swap provider',
      },
      delayed: {
        short: 'Delayed',
        title: 'Unstake after 6 months',
        description:
          'ICP will be sent to your wallet as soon as the 6 months dissolve delay has elapsed',
      },
      receive: 'Receive',
      swapUnavailable: 'Swap unavailable',
      noSwapOffers: 'No swap offers available currently',
    },
    review: {
      title: {
        stake: 'Staking review',
        unstake: 'Review unstaking',
      },
      stake: 'Stake',
      unstake: 'Unstake',
      unstakeMode: 'Mode',
      swapProvider: 'Swap Provider',
      fee: 'Fee',
      feeAmount: `{{fee}}% + transaction fees`,
    },
    error: {
      title: 'Error occurred 😔',
      description: 'Something unexpected happened, please try again later',
    },
  },
  importWalletStoic: {
    seedPhrasePlaceholder: 'Place your stoic seed phrase here',
    subbaccountWarning:
      'Note that due to the fact, that Plug does not support subaccounts and all our accounts have seperate principal ID, currently this will only import you main Stoic identity.',
    seedPhraseInfo: "Plug won't backup this seed phrase, but just generate the identity",
    import: 'IMPORT',
  },
  contactForm: {
    edit: 'Edit Contact',
    add: 'Add Contact',
    name: 'Name',
    address: 'Address',
    delete: 'Delete',
    save: 'Save',
  },
  llmChat: {
    inputPlaceholder: 'Type your question...',
    failedAuthMessage: `#### I've failed to authenticate you 🥸

Please try reloading the page or try again later!

If the issue persists, please contact our support team 🙋

You can find our support here - https://support.plugwallet.ooo`,
  },
  earn: {
    title: 'Earn',
    myPositions: 'My positions',
    openPositions: 'Your Earn Positions',
    openNew: 'Open new position',
    noPositions: 'No open positions',
    noPositionsDescription: 'Start earning by depositing into a vault',
    noVaults: 'No vaults found',
    noVaultsDescription: 'Try adjusting your filters.',
    allChains: 'All chains',
    allProtocols: 'All protocols',
    allAssets: 'All assets',
    sortLabel: 'Sort: {{sort}}',
    filterByChain: 'Filter by chain',
    filterByProtocol: 'Filter by protocol',
    filterByAsset: 'Filter by asset',
    sortBy: 'Sort by',
    selected: 'Selected',
    select: 'Select',
    apyHighest: 'APY (highest first)',
    tvlHighest: 'TVL (highest first)',
    tvl: 'TVL',
    protocol: 'Protocol',
    chain: 'Chain',
    asset: 'Asset',
    apy: 'APY',
    baseApy: 'Base APY',
    rewardApy: 'Reward APY',
    viewOn: 'View on {{protocol}}',
    startEarning: 'Start earning',
    depositMore: 'Deposit more to this vault',
    yourDeposit: 'Your deposit',
    vaultDetailsError: 'Could not load vault details',
    deposit: {
      title: 'Deposit',
      vault: 'Vault',
      gasFee: 'Gas fee',
      projectedMonthly: 'Projected monthly earnings',
      projectedYearly: 'Projected yearly earnings',
      reviewTitle: 'Review deposit',
      depositButton: 'Confirm deposit',
      depositValue: 'Deposit value',
      completed: 'Deposit Completed',
      depositFailed:
        'Failed to deposit, please try again. Please contact support if the issue persists.',
      unsupportedToken: 'Token not supported',
      notEnoughBalance: 'Not enough {{token}}',
      notEnoughForGas: 'Not enough {{token}} for gas fee',
      quoteFailed: 'Could not fetch quote',
    },
    withdraw: {
      title: 'Withdraw',
      amount: 'Withdraw amount',
      youReceive: 'You receive',
      available: 'Available: {{amount}}',
      exceedsBalance: 'Exceeds available balance',
      withdraw: 'Withdraw',
      reviewTitle: 'Review withdraw',
      withdrawButton: 'Confirm withdraw',
      completed: 'Withdraw Completed',
      withdrawFailed:
        'Failed to withdraw, please try again. Please contact support if the issue persists.',
      alreadyWithdrawn: 'Position already withdrawn',
    },
  },
  defi: {
    title: 'DeFi Hub',
    stake: {
      title: 'Stake',
      description: 'Earn rewards by staking ICP',
    },
    earn: {
      title: 'Earn',
      description: 'Deposit into vaults and earn yield',
    },
    liquidium: {
      title: 'Borrow & Lend',
      description: 'Borrow and lend assets on Liquidium',
    },
    borrow: {
      title: 'Borrow/Lend',
      description: 'Coming soon',
    },
    topup: {
      title: 'Cycle Top Up',
      description: 'Mint cycles and create rules',
    },
    mint: {
      title: 'Mint CK',
      description: 'Mint Chain-Key tokens',
    },
    onesec: {
      title: 'Bridge to EVM',
      description: 'ICP → EVM asset bridge',
    },
    odin: {
      title: 'Bridge to Odin',
      description: 'Trade BTC fast on Odin.fun',
    },
    perps: {
      title: 'Perpetual futures',
      description: 'Go Long or Short with built-in Hyperliquid Perps',
    },
  },
  topup: {
    title: 'Top-Up',
    tcyclesBalance: 'TCYCLES Balance',
    plugBalance: 'Plug Balance',
    approved: 'Approved',
    topupCanister: '⛽️ Instant top-up',
    topupHistory: 'Top Up history',
    savedCanisters: 'Saved Canisters',
    noCanisters: 'No Canisters Added',
    noCanistersDescription: 'Add canister to manage their cycles and auto top up rules',
    addCycles: '⛽️ Add cycles',
    modes: {
      mint: '🍀 Mint cycles from ICP',
      approve: ' ✅ Approve cycles for auto top up',
    },
    deleteWarning: {
      title: 'Remove canister',
      description:
        'Are you sure you want to remove canister (you can always add it back again later)',
    },
    canisterForm: {
      canisterId: 'Canister ID',
      name: 'Name',
      autoTopup: 'Enable Auto Top-Up',
      topupAmount: 'Amount',
      topupThreshold: 'Threshold',
      topupMode: 'Top-up mode',
      sns: 'SNS project',
    },
    saveError: {
      InvalidInput: 'Invalid Input',
      NotAllowed: 'Action not allowed',
      Duplicate: 'Canister already exists',
      NotBlackholed: 'Blackhole is not controller of this canister',
      NotFound: 'Not Found',
      General: 'Unknown error',
    },
    canisterCard: {
      topUp: 'Top-Up',
      cyclesLeft: 'Cycles left: {{cycles}}',
      autoTopupOff: 'Auto top up is turned off',
      edit: 'Edit canister',
      delete: 'Delete canister',
    },
    Manual: {
      title: 'Manual Top-Up',
      description:
        'You top-up canister manually from Plug Wallet, balance is available only if Plug wallet principal is controller of the canister',
    },
    SNS: {
      title: 'SNS Canister',
      description:
        'You can see canister balance, top-up automatically and manually. For automatic balance check you need to select SNS project entered canister belongs to',
    },
    Blackhole: {
      title: 'Blackhole',
      description:
        'Blackhole canister (e3mmv-5qaaa-aaaah-aadma-cai) is controller of your canister. This allows Plug to check balances and perform automatic top-up',
    },
    notEnoughBalance:
      'Last auto top-up was not successfull, please check TCYCLES balance and approve amount are sufficient',
    types: {
      SNS: '🤖 SNS - Automatic Top-up',
      Blackhole: '🤖 Blackhole - Automatic Top-up',
      Manual: '⛽️ Manual Top-up',
      Unknown: '❓ Unknown',
    },
  },
  topupHistory: {
    empty: 'No top-up history found',
  },
  addresses: {
    icpPrincipal: 'Principal ID',
    icpAccount: 'Account ID',
    btcAddress: 'BTC Address',
    ethAddress: '{{chain}} Address',
    solAddress: 'SOL Address',
    odinAddress: 'Odin Address',
    dogeAddress: 'DOGE Address',
  },
  chains: {
    select: '🔗 Select Chain',
    addMore: 'Add more',
    long: {
      all: 'Chain Fusion',
      icp: 'ICP',
      eth: 'Ethereum',
      btc: 'Bitcoin',
      sol: 'Solana',
      odin: 'Odin',
      arb: 'Arbitrum',
      base: 'Base',
      doge: 'Doge',
    },
    short: {
      all: 'All',
      icp: 'ICP',
      eth: 'ETH',
      btc: 'BTC',
      sol: 'SOL',
      odin: 'Odin',
      arb: 'ARB',
      base: 'BASE',
      doge: 'DOGE',
    },
  },
  accounts: {
    editProfile: 'Edit Profile',
    shareProfile: 'Share Profile',
    otherAccounts: 'Other accounts',
    addNew: 'Add another wallet',
    failedtoSave: 'Failed to save, please try again',
    plugbookName: 'Plugbook Name',
    plugbookNameDescription:
      'Plugbook name is your unique username that others can use to send assets to your wallet',
    walletName: 'Wallet name',
    walletNameDescription: 'Your wallet name is visible only to you',
    selectPictureType: 'Select Picture Type',
    emojiPicture: '👽 Use Emoji',
    nftPicture: '🎆 Use NFT',
    selectNft: 'Select NFT',
    profileShared: 'Copied link to your profile!',
  },
}
